/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AwbMode {
}

export enum AwbMode_Enum {
  AWB_MODE_AUTO = 0,
  AWB_MODE_2300K = 2300,
  AWB_MODE_2800K = 2800,
  AWB_MODE_3200K = 3200,
  AWB_MODE_3800K = 3800,
  AWB_MODE_4300K = 4300,
  AWB_MODE_4800K = 4800,
  AWB_MODE_5000K = 5000,
  AWB_MODE_5400K = 5400,
  AWB_MODE_5600K = 5600,
  AWB_MODE_5800K = 5800,
  AWB_MODE_6000K = 6000,
  AWB_MODE_6500K = 6500,
  AWB_MODE_7500K = 7500,
  UNRECOGNIZED = -1,
}

export function awbMode_EnumFromJSON(object: any): AwbMode_Enum {
  switch (object) {
    case 0:
    case "AWB_MODE_AUTO":
      return AwbMode_Enum.AWB_MODE_AUTO;
    case 2300:
    case "AWB_MODE_2300K":
      return AwbMode_Enum.AWB_MODE_2300K;
    case 2800:
    case "AWB_MODE_2800K":
      return AwbMode_Enum.AWB_MODE_2800K;
    case 3200:
    case "AWB_MODE_3200K":
      return AwbMode_Enum.AWB_MODE_3200K;
    case 3800:
    case "AWB_MODE_3800K":
      return AwbMode_Enum.AWB_MODE_3800K;
    case 4300:
    case "AWB_MODE_4300K":
      return AwbMode_Enum.AWB_MODE_4300K;
    case 4800:
    case "AWB_MODE_4800K":
      return AwbMode_Enum.AWB_MODE_4800K;
    case 5000:
    case "AWB_MODE_5000K":
      return AwbMode_Enum.AWB_MODE_5000K;
    case 5400:
    case "AWB_MODE_5400K":
      return AwbMode_Enum.AWB_MODE_5400K;
    case 5600:
    case "AWB_MODE_5600K":
      return AwbMode_Enum.AWB_MODE_5600K;
    case 5800:
    case "AWB_MODE_5800K":
      return AwbMode_Enum.AWB_MODE_5800K;
    case 6000:
    case "AWB_MODE_6000K":
      return AwbMode_Enum.AWB_MODE_6000K;
    case 6500:
    case "AWB_MODE_6500K":
      return AwbMode_Enum.AWB_MODE_6500K;
    case 7500:
    case "AWB_MODE_7500K":
      return AwbMode_Enum.AWB_MODE_7500K;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AwbMode_Enum.UNRECOGNIZED;
  }
}

export function awbMode_EnumToJSON(object: AwbMode_Enum): string {
  switch (object) {
    case AwbMode_Enum.AWB_MODE_AUTO:
      return "AWB_MODE_AUTO";
    case AwbMode_Enum.AWB_MODE_2300K:
      return "AWB_MODE_2300K";
    case AwbMode_Enum.AWB_MODE_2800K:
      return "AWB_MODE_2800K";
    case AwbMode_Enum.AWB_MODE_3200K:
      return "AWB_MODE_3200K";
    case AwbMode_Enum.AWB_MODE_3800K:
      return "AWB_MODE_3800K";
    case AwbMode_Enum.AWB_MODE_4300K:
      return "AWB_MODE_4300K";
    case AwbMode_Enum.AWB_MODE_4800K:
      return "AWB_MODE_4800K";
    case AwbMode_Enum.AWB_MODE_5000K:
      return "AWB_MODE_5000K";
    case AwbMode_Enum.AWB_MODE_5400K:
      return "AWB_MODE_5400K";
    case AwbMode_Enum.AWB_MODE_5600K:
      return "AWB_MODE_5600K";
    case AwbMode_Enum.AWB_MODE_5800K:
      return "AWB_MODE_5800K";
    case AwbMode_Enum.AWB_MODE_6000K:
      return "AWB_MODE_6000K";
    case AwbMode_Enum.AWB_MODE_6500K:
      return "AWB_MODE_6500K";
    case AwbMode_Enum.AWB_MODE_7500K:
      return "AWB_MODE_7500K";
    case AwbMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAwbMode(): AwbMode {
  return {};
}

export const AwbMode = {
  encode(_: AwbMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AwbMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAwbMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AwbMode {
    return {};
  },

  toJSON(_: AwbMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AwbMode>, I>>(base?: I): AwbMode {
    return AwbMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AwbMode>, I>>(_: I): AwbMode {
    const message = createBaseAwbMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
